import { getV1CompaniesCompanyIdJobsJobIdLocationHistories } from '@treadinc/horizon-api-spec';
import { useCallback } from 'react';

import { MAX_LOCATION_HISTORY_PAGE_SIZE } from '~constants/consts';
import { LocationHistoryMinimal } from '~hooks/useLocationHistory/models';
import { getLocationHistoriesByMovingSite } from '~hooks/useLocationHistory/useLocationHistory';
import { fetchAllApiPages } from '~utils/fetchAllPages';

export const useLiveMap = (companyId: string) => {
  // Unlike getLocationHistoriesByJobId, this keeps the API's default soft limit,
  // which leaves low-accuracy pings out of the drawn route.
  const getAllLocationsByJobId = useCallback(
    (jobId: string) =>
      fetchAllApiPages(
        (query) =>
          getV1CompaniesCompanyIdJobsJobIdLocationHistories({
            path: { 'company-id': companyId, 'job-id': jobId },
            query,
          }),
        LocationHistoryMinimal.parse,
        { pageSize: MAX_LOCATION_HISTORY_PAGE_SIZE },
      ),
    [companyId],
  );

  const fetchTreadRoute = useCallback(
    async (jobId: string) => {
      const data = await getAllLocationsByJobId(jobId);
      // Sort pings chronologically by occurredAt timestamp
      return data.sort((a, b) => a.occurredAt.valueOf() - b.occurredAt.valueOf());
    },
    [getAllLocationsByJobId],
  );

  const fetchTreadMovingGeofenceRoute = useCallback(
    (jobId: string, movingSiteId: string) =>
      getLocationHistoriesByMovingSite(companyId, jobId, movingSiteId),
    [companyId],
  );

  return {
    fetchTreadRoute,
    fetchTreadMovingGeofenceRoute,
  };
};
